import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeSetLike, curveGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {FlipOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/flip-operator/geometry-flip-operator-node"
import {GeometryFlipOperatorNode, flipOperatorParametersSchema} from "#template/nodes/geometry-graph/attribute-set/flip-operator/geometry-flip-operator-node"

export type CurveGeometryFlipOperatorParameters = FlipOperatorParameters<CurveGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryFlipOperatorParameters> = {
    nodeClass: "CurveGeometryFlipOperator",
    validation: {
        parameters: flipOperatorParametersSchema(curveGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryFlipOperator extends GeometryFlipOperatorNode<1, CurveGeometryAttributeSetLikeNode> implements CurveGeometryAttributeSetLikeNode {
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
